module.exports = __webpack_public_path__ + "media/images/check-green-57573148.svg";